// extracted by mini-css-extract-plugin
module.exports = {"returns__wrapper":"styles_returns__wrapper___Zd_9","returns__contentWrapper":"styles_returns__contentWrapper__N_0CO"};